export default __webpack_public_path__ + "static/media/menu1_hl.87d1936b.png";